const rpcUrl = 'https://dream-rpc.somnia.network/',
    blockExplorers = 'https://shannon-explorer.somnia.network/'
export default {
    id: 50312,
    name: 'Somnia Testnet',
    network: 'somnia-testnet',
    nativeCurrency: {name: 'STT', symbol: 'STT', decimals: 18},
    rpcUrls: {
        default: {
            http: [rpcUrl],
        },
        public: {
            http: [rpcUrl],
        },
    },
    blockExplorers: {
        etherscan: {name: 'Somniatestnet', url: blockExplorers},
        default: {name: 'Somniatestnet', url: blockExplorers},
    },
    contracts: {},
}